import ServiceManager from './ServiceManager';
export default function service(id) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function serviceRegister(target) {
    ServiceManager.register(id, target, options);
  };
}